import Button from '@components/common/Button';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    display: none;
  }
`;
